module.exports = __webpack_public_path__ + "static/VoteYay_Logo_Horizontal_4C_small.95cb8bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/VoteYay_Logo_Horizontal_4C_small.png
// module id = 383
// module chunks = 264074303502183